import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HumanCapitalEmployeeActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/Employee/EmployeeBrowser")
	}

	render() {
		return (
			<Activity 
				name="HumanCapitalEmployee"
				RenderedComponent={this.RenderedComponent}
				context="HumanCapitalEmployee"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HumanCapitalEmployeeActivity)
